import { OTHER_PRONOUN_CHOICE, PRONOUN_OPTIONS } from '../constants/pronouns';

// `radioValue` is `''` when nothing is selected, never `undefined`: `undefined` would hand Radix an
// uncontrolled group that flips to controlled on the first pick. No option has an empty value.
export type PronounSelection = {
    isFixedChoice: boolean;
    isOtherSelected: boolean;
    radioValue: string;
};

function isFixedPronoun(pronouns: string | null | undefined) {
    return PRONOUN_OPTIONS.some((option) => option.value === pronouns);
}

// A saved pronoun outside the fixed options opens as Other with the saved text still in the
// free-text box.
export function hasCustomPronoun(pronouns: string | null | undefined) {
    return !!pronouns && !isFixedPronoun(pronouns);
}

// `otherManuallySelected` is the sticky half: the pronouns fields seed it from
// `hasCustomPronoun` of the saved value and sets it when the therapist clicks Other, so Other
// outlives the text that selected it. Deriving it from the live text alone would deselect Other —
// and unmount the input showing the error — on the keystroke that clears the text.
export function derivePronounSelection(
    pronouns: string | null,
    otherManuallySelected: boolean,
): PronounSelection {
    const isFixedChoice = isFixedPronoun(pronouns);
    const isOtherSelected = otherManuallySelected || hasCustomPronoun(pronouns);

    return {
        isFixedChoice,
        isOtherSelected,
        radioValue: isOtherSelected ? OTHER_PRONOUN_CHOICE : isFixedChoice ? (pronouns ?? '') : '',
    };
}
